import { useQuery } from "@tanstack/react-query";
import { getBloomreachStatus } from "../../api/bBloomreachApi";

export const useGetBloomreachStatus = (organisationId, enabled = true) => {
  return useQuery({
    queryKey: ["bloomreach-status", organisationId],
    queryFn: () => getBloomreachStatus(organisationId),
    enabled: Boolean(organisationId) && enabled,
  });
};
